export default __webpack_public_path__ + "images/icons/plus-bold-a4b25e9c8a758b0316086aaf8ea5a8ea.svg";